// src/pages/InteligenciaArtificial.jsx
import React from "react";

const InteligenciaArtificial = () => {
  return <div>Componente de Inteligencia Artificial</div>;
};

export default InteligenciaArtificial;
